<template>
    <HeaderContent title="Program"/>
    <ActionContent :filter-date="false" ctaText="Program" @action="modal = !modal "/>
    <ProgramForm :modal="modal"  @update:modal="modal = $event"></ProgramForm>
    <DataTable :data="data" :header="header" :currentPage="currentPage" :custom-actions="customActions"></DataTable>
    <ProgramDetail dataDetail="modalDetail.data" :modal="modalDetail.togle" @update:modal="modalDetail.togle = $event"></ProgramDetail>
</template>

<script>
import { ref,} from 'vue';
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import DataTable from '@/components/DataTable.vue';
import ProgramDetail from './action/ProgramDetail.vue';
import {programData} from '@/dummy-data/program'
import ProgramForm from './ProgramForm.vue';

export default {
    name : 'ProgramIndex',
    components : {
        HeaderContent,
        ActionContent,
        ProgramForm,
        DataTable,
        ProgramDetail
    },
    setup(){
        const modal = ref(false)
        const modalDetail = ref({
            togle : false,
            data : []
        })
        const currentPage = ref(1)
        const data = programData
        const header = [
            {key : 'name', label : 'Program Name',sortable: true,},
            {key : 'destination', label : 'Destination',sortable: true,},
            {key : 'accommodation', label : 'Accommodation',sortable: true,},
            {key : 'activity', label : 'Activity',sortable: true,},
            {key : 'price', label:'Price',sortable: true,},
            {key : 'action', label:'Action'}
        ]
        const customActions = ref([
        {
            label: 'Detail',
            variant: 'secondary',
            icon: 'fas fa-ellipsis-v',
            action: () => {
                modalDetail.value = !modalDetail.value
            }
        },
        
        {
            label: 'Edit',
            variant: 'success',
            icon: 'fas fa-edit',
            action: (item) => {
            console.log('Edit action clicked for:', item);
            // Implement your edit logic here
            }
        },
        {
            label: 'Delete',
            variant: 'danger',
            icon: 'fas fa-trash',
            action: (item) => {
            console.log('Delete action clicked for:', item);
            // Implement your delete logic here
            }
        },
        
      ]);

        return {
            modal,
            modalDetail,
            customActions,
            currentPage,
            data,
            header
        }
    }
}

</script>